<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface LoadErrorProps {
  title?: string
  message?: string
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '#ui-kit/ui/empty'

const props = withDefaults(defineProps<LoadErrorProps>(), {
  title: 'Unable to load data',
  message: 'Something went wrong while loading the data. Please try again later.',
})
</script>

<template>
  <Empty :class="props.class">
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <ExclamationTriangleIcon aria-hidden="true" />
      </EmptyMedia>

      <EmptyTitle>{{ title }}</EmptyTitle>

      <EmptyDescription v-if="message">{{ message }}</EmptyDescription>
    </EmptyHeader>
  </Empty>
</template>
